import React from "react";
import { Typography, Box, Grid, Chip } from "@mui/material";

const videosPath = "https://demo.chinookdt.com/videos/";
const videos = [
  {
    id: "1",
    src: "1.mp4",
    title: "Piping & Inst spec and estimation",
  },
  {
    id: "2",
    src: "2.mp4",
    title: "Trim List Extraction",
  },
  {
    id: "3",
    src: "3.mp4",
    title: "3D Edits, 2D Edits, Line List , BOM",
  },
  { id: "4", src: "4.mp4", title: "Validation" },
];
export default function OnboardingPage() {
  return (
    <Grid container sx={{ px: 20 }}>
      <Grid item xs={12}>
        <Typography
          variant="h4"
          sx={{ pt: 2, pb: 1, pl: 2, textAlign: "center" }}
        >
          Onboarding Videos
        </Typography>
        <Typography variant="h5" sx={{ pb: 1, pl: 2, textAlign: "center" }}>
          Piping & Instrumentation
        </Typography>
      </Grid>
      {videos.map((v) => {
        return (
          <Grid item xs={6} key={v.title}>
            <VideoCard video={v} />
          </Grid>
        );
      })}
    </Grid>
  );
}

const VideoCard = ({ video }) => {
  return (
    <Box
      sx={{
        m: 2,
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        overflow: "hidden",
      }}
    >
      <Box>
        <video width="100%" height="auto" controls style={{}}>
          <source src={videosPath + video.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <Typography
          variant="h5"
          sx={{ backgroundColor: "white", py: 3, px: 2 }}
        >
          <Chip
            label={video.id}
            color="primary"
            sx={{ transform: "translateY(-3px)", mx: 1 }}
          />{" "}
          {video.title}
        </Typography>
      </Box>
    </Box>
  );
};
